import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useActiveBrand } from '../../components/branding/useActiveBrand';
import { VisitorState, visitorNameAtom, visitorStateAtom } from '../state';
import { setDefaultWaitingRoomFaviconAndTitle } from '../waiting-room/metadata';

export function useEnterWaitingRoomCallback() {
  const activeBrand = useActiveBrand();
  const setVisitorName = useSetAtom(visitorNameAtom);
  const setVisitorState = useSetAtom(visitorStateAtom);

  return useCallback(
    (visitorName: string) => {
      setVisitorName(visitorName);
      setVisitorState(VisitorState.WAITING);
      setDefaultWaitingRoomFaviconAndTitle(activeBrand);
    },
    [setVisitorName, setVisitorState, activeBrand],
  );
}
